import React from 'react'
import styles from './PlanningModalSeparation.module.css'

const PlanningModalSeparation = () => (
  <div className={styles.separation}/>
)

export default PlanningModalSeparation
